import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import NextModal from "../../../presentational/Modals/NextModal/NextModal";
import { RootState } from "../../../../types/State.interface";
import { User } from "../../../../types/User.interface";

import "swiper/swiper.scss";
import styles from "./IdeasPhotoBrowser.module.scss";
import IdeaPhotoCard from "../../../presentational/Cards/IdeaPhotoCard/IdeaPhotoCard";

const IdeasPhotoBrowser = (props) => {
  const user: User = useSelector((state: RootState) => state.user.userDetails);
  const renderContent = () => (
    <div className={styles.wrapper}>
      <div className={styles.body}>
        <IdeaPhotoCard
          key={props.idea.id}
          idea={props.idea}
          onAuthorClick={props.onAuthorClick}
          onLike={props.onLike}
          user={user}
          className={styles.card}
          isModalView
          isMediaCard={props.idea.isMediaCard}
        />
      </div>
    </div>
  );

  return (
    <NextModal
      class={classNames(styles.modal, props.className)}
      overlayClass={styles.overlay}
      isOpened={props.isOpened}
      canSlidePrev={props.canSlidePrev}
      canSlideNext={props.canSlideNext}
      onSlidePrev={props.onSlidePrev}
      onSlideNext={props.onSlideNext}
      onClose={props.onClose}
    >
      {renderContent()}
    </NextModal>
  );
};

export default IdeasPhotoBrowser;
